export default __webpack_public_path__ + "static/studiostrack-logo-10f2e9054b3f0d850077e0a35f23c57a.svg";